module.exports = __webpack_public_path__ + "static/media/illustrations-car-spinner-24.29dbd63d.gif";